import React from 'react'
import Pagination from '@src/routes/SemiConfigurators/components/Pagination'
import { configContext } from '../Sirna'

const PaginationForSirna = () => {
  const { state, dispatch } = React.useContext(configContext)
  const [page, setPage] = React.useState(state.paginationData.page)
  const [noOfPage, setNoOfPage] = React.useState(1)
  const { searchResult } = state

  const perPage = state.perPageCount

  const pageCount = state.paginationData.totalCount

  const handlePageChange = (page: number) => {
    if (state.stepNo) {
      dispatch({ type: 'TRACE_ON_CLICK', data: true })
    }
    setPage(page)
    return page
  }

  React.useEffect(() => {
    if (searchResult.count !== 0) {
      let result: number
      result = 1
      const updatedPageCount =
        pageCount / (perPage === 'All' ? pageCount : parseInt(perPage))
      result = Math.ceil(updatedPageCount)
      setNoOfPage(result)
    }
    // TODO: need a test before we refactor these dependencies
  }, [searchResult, pageCount])

  React.useEffect(() => {
    if (page !== undefined) {
      dispatch({
        type: 'SEARCH_INPUT',
        data: {
          ...state.searchInput,
          page: page,
        },
      })
      dispatch({
        type: 'UPDATE_PAGINATION_DATA',
        data: {
          ...state.paginationData,
          page: page,
        },
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [page])

  React.useEffect(() => {
    window.scrollTo(0, 480)
  }, [page])

  React.useEffect(() => {
    if (
      (state.stepNo === 1 &&
        state.traceOnClick &&
        state.searchInput.term.length) ||
      (state.stepNo === 0 && !state.traceOnClick)
    ) {
      setPage(1)
    }
  }, [state.searchInput.facet, state.searchInput.term, state.searchInput.count])

  return (
    <Pagination
      curPage={page}
      numPages={noOfPage}
      clickHandler={handlePageChange}
    />
  )
}

export default PaginationForSirna
